import { forwardRef } from "react";
import './inputArea.css';

interface InputAreaProps {
    label: string;
    placeholder?: string;
    error?: string;
    value?: string | null;
    onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
    onBlur?: () => void; 
    name: string;
    styleLabel?: string;
    styleArea?: string;
}

const InputArea = forwardRef<HTMLTextAreaElement, InputAreaProps>(
    ({ label, name, placeholder = "", error, value = "", onChange, onBlur, styleLabel, styleArea }, ref) => {
        const id = `input-${name}`;
        const labelClass = styleLabel;
        const areaClass = styleArea;
        return (
            <div className="flex flex-col w-full items-start">
                <label htmlFor={id} className={`font-medium mb-[4px] ${labelClass}`}>
                    {label}
                </label>
                <textarea
                    ref={ref}
                    id={id}
                    name={name}
                    value={value ?? ""}
                    onChange={onChange}
                    onBlur={onBlur}
                    placeholder={placeholder}
                    className={`${areaClass} outline-none border border-[#e0e0e0] rounded-[4px] py-[4px] px-[8px] w-full min-h-[80px] focus:border-[#3498db] focus:ring-1 focus:ring-[#3498db] transition-all duration-200 h-[110px]`}
                />
                <div className="h-[20px] mt-1">
                    {error && <p className="text-red-500 text-sm">{error}</p>}
                </div>            </div>
        );
    }
);

export default InputArea;
